module.exports = __webpack_public_path__ + "static/media/user.551e3f46.svg";